import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'

const userLanguage = navigator.language || navigator.userLanguage; // Detecta el idioma del navegador
const defaultLanguage = userLanguage.includes('es') ? 'es' : 'en';

i18n.use(initReactI18next).init({
  lng: defaultLanguage, // Default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
  },
})

export default i18n
